import cn from 'classnames'
import styles from './style.module.css'
import { Link } from 'react-router-dom'

const Button = ({
    children,
    modifier = 'style_light-blue',
    href,
    clickHandler,
    className,
    disabled,
    type = 'button'
}) => {
    const classNames = cn(styles.button, className, {
        [styles[`button_${modifier}`]]: modifier,
        [styles.button_disabled]: disabled
    })
    if (href) {
        return <Link
            className={classNames}
            to={href}
        >
            {children}
        </Link>
    }
    return <button
        type={type}
        className={classNames}
        disabled={disabled}
        onClick={_ => clickHandler && clickHandler()}
    >
        {children}
    </button>
}


export default Button